var map = {
	"./monster-1.png": 1057,
	"./monster-2.png": 1058,
	"./monster-23.png": 1059,
	"./monster-3.png": 1060,
	"./monster-4.png": 1061,
	"./monster-5.png": 1062,
	"./monster-6.png": 1063,
	"./monster-7.png": 1064,
	"./monster-8.png": 1065,
	"./monster-9.png": 1066
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;



//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters ^\.\/monster\-.*\.png$
// module id = 368
// module chunks = 0